import {
  apiURL
} from '../../config/app';

const getToken = async userData => {
  const response = await fetch(`${apiURL}/oauth/access_token`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(userData)
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const signOut = async authToken => {
  const response = await fetch(`${apiURL}/oauth/access_token`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  
  return response.json();
};

const getProfile = async authToken => {
  const response = await fetch(`${apiURL}/profile`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

export default {
  getToken,
  getProfile,
  signOut  
};



// WEBPACK FOOTER //
// ./api/auth.js